import {contentProvider} from './src';

export * from './src';
export default contentProvider;



/** WEBPACK FOOTER **
 ** ./client/shared/packages/contentProvider/index.js
 **/